import { render, staticRenderFns } from "./AdditionalFieldsEmail.vue?vue&type=template&id=5a5ee998&scoped=true&lang=pug&"
import script from "./AdditionalFieldsEmail.vue?vue&type=script&lang=ts&"
export * from "./AdditionalFieldsEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5ee998",
  null
  
)

export default component.exports